/**
 * Afghanistan Region Data
 * Comprehensive data for Afghanistan
 */

import { Region } from "../../types/regions";

/**
 * Afghanistan region with current borders
 */
export const AFGHANISTAN_REGION: Region = {
  id: "region-afghanistan",
  code: "afghanistan",
  name: "Afghanistan",
  localizedNames: {
    en: "Afghanistan",
    fa: "افغانستان",
    ps: "افغانستان", // Pashto
    ar: "أفغانستان",
    uz: "Afgʻoniston", // Uzbek
    tk: "Owganystan", // Turkmen
  },
  description: "Afghanistan, a landlocked country at the crossroads of Central and South Asia",
  // Border data is loaded from src/data/borders/afghanistan.json via getRegionBorder()

  viewport: {
    center: { lat: 33.9391, lng: 67.7100 },
    zoom: 6,
    minZoom: 5,
    maxZoom: 18,
  },

  area: 652230, // Square kilometers

  status: "hidden",
  visibility: "admin",

  features: {
    canCreateMaps: true,
    canViewPublicMaps: true,
    canUseTemplates: true,
    hasHistoricalData: true,
  },

  defaultMapStyle: "topography",
  themeColor: "#000000", // Black from Afghan flag
  flagEmoji: "🇦🇫",
  thumbnailUrl: "/images/regions/afghanistan-thumbnail.jpg",

  historicalPeriods: [
    {
      id: "ancient",
      name: "Ancient Period",
      startYear: -3000,
      endYear: -500,
      description: "Early civilizations including Bactria and Gandhara",
    },
    {
      id: "greco-bactrian",
      name: "Greco-Bactrian Period",
      startYear: -250,
      endYear: -125,
      description: "Greek influence following Alexander's conquests",
    },
    {
      id: "kushan",
      name: "Kushan Empire",
      startYear: 30,
      endYear: 375,
      description: "Height of Buddhism in Afghanistan",
    },
    {
      id: "islamic",
      name: "Islamic Period",
      startYear: 652,
      endYear: 1500,
      description: "Various Islamic dynasties including Ghaznavids and Timurids",
    },
    {
      id: "durrani",
      name: "Durrani Empire",
      startYear: 1747,
      endYear: 1823,
      description: "Ahmad Shah Durrani and the founding of modern Afghanistan",
    },
    {
      id: "anglo-afghan",
      name: "Anglo-Afghan Wars",
      startYear: 1839,
      endYear: 1919,
      description: "Period of British influence and resistance",
    },
    {
      id: "kingdom",
      name: "Kingdom of Afghanistan",
      startYear: 1926,
      endYear: 1973,
      description: "The Afghan monarchy period",
    },
    {
      id: "modern",
      name: "Modern Era",
      startYear: 1973,
      endYear: undefined,
      description: "Republic era through present day",
    },
  ],

  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
  order: 6,
  tags: ["central-asia", "south-asia", "pashtun", "tajik", "hazara", "uzbek", "landlocked"],
};

